{
  "en": {
    "textExtract": {
      "alerts": {
        "limitReached": "You have reached your text extraction limit."
      },
      "buttons": {
        "extract": "Extract Text",
        "processing": "Processing..."
      },
      "errors": {
        "processingFailed": "Text extraction failed. Please try again."
      },
      "inputKinds": {
        "file": {
          "dropTitle": "Drag file here or {select}",
          "dropTitleSelect": "select",
          "help": "Drop or select a file here. Supported formats include images, PDF, text, audio, and common Office and OpenOffice formats up to {limit} MB.",
          "label": "File",
          "maxSize": "Maximum {limit} MB",
          "placeholder": "Select file",
          "title": "File",
          "icon": "bi-file-earmark"
        },
        "audio": {
          "help": "Note: You can upload a file directly by dragging and dropping it here. We support .mp3, .mp4, .mp4a oder .wav files up to {limit}MB.",
          "icon": "bi-file-music",
          "label": "Audio File",
          "placeholder": "Select audio file",
          "title": "Audio File"
        },
        "image": {
          "help": "Note: You can upload a file directly by dragging and dropping it here. We support .jpeg, .png files up to {limit}MB.",
          "icon": "bi-file-image",
          "label": "Image File",
          "placeholder": "Select image file",
          "title": "Image"
        },
        "pdf": {
          "help": "Note: You can upload a file directly by dragging and dropping it here. We support .pdf files up to {limit}MB.",
          "icon": "bi-file-earmark-pdf",
          "label": "PDF File",
          "placeholder": "Select PDF file",
          "title": "PDF"
        },
        "video": {
          "help": "Note: You can upload a file directly by dragging and dropping it here. We support .mp4, .mp4v, .avi or .mkv files up to {limit}MB.",
          "icon": "bi-film",
          "label": "Video File",
          "placeholder": "Select video file",
          "title": "Video File"
        },
        "website": {
          "label": "Website URL",
          "placeholder": "https://fobizz.com/en/ai-assistance-fobizz-tools/",
          "title": "Website",
          "help": "Example: https://fobizz.com/en/ai-assistance-fobizz-tools/",
          "icon": "bi-globe"
        },
        "youtube": {
          "label": "YouTube URL or Search",
          "placeholder": "Enter YouTube URL or search for videos...",
          "title": "YouTube",
          "help": "Paste a YouTube URL or search for videos to transcribe",
          "icon": "bi-youtube"
        },
        "text": {
          "label": "Text",
          "placeholder": "You can insert background knowledge here...",
          "title": "Text"
        }
      },
      "labels": {
        "language": "Language",
        "inputType": "Input Type"
      },
      "modal": {
        "title": "Extract Text"
      },
      "sourcePicker": {
        "addNew": "Add new",
        "recent": "Recently used"
      },
      "upload": {
        "success": "File uploaded successfully"
      },
      "options": {
        "languages": {
          "auto": "Auto detect"
        }
      },
      "youtube": {
        "noResults": "No videos found for your search.",
        "searchError": "Error searching videos. Please try again."
      },
      "privacyHint": "Do not share sensitive information or personal data of students with AI."
    }
  }
}
